<div class="w-full p-6 bg-mbaza-gray-dark grid place-items-center text-center">
    <span>Mbaza &copy; {{year}}</span>
</div>
